import { IEvaluationService } from "../../service/evaluation/EvaluationService";

export default class GetEvaluationRuleGroupsInteractor {
  private evaluationService: IEvaluationService;

  constructor(evaluationService) {
    this.evaluationService = evaluationService;
  }

  async execute(evaluationReviewId: number) {
    return this.evaluationService.getEvaluationRuleGroups(evaluationReviewId);
  }
}
